export const LOGIN = "LOGIN";
export const REQUEST_RESET_PASSWORD = "REQUEST_RESET_PASSWORD";
export const CONFIRM_RESET_PASSWORD = "CONFIRM_RESET_PASSWORD";
export const GET_USER_ME = "GET_USER_ME";
export const GET_CONGRESS = "GET_CONGRESS";
export const SIGN_UP = "SIGN_UP";
export const GET_COUNTRIES = "GET_COUNTRIES";
export const CHECK_ACCESS_CODE = "CHECK_ACCESS_CODE";
export const LOGOUT = "LOGOUT";
export const GET_LIVE_SESSIONS = "GET_LIVE_SESSIONS";
export const GET_PAST_SESSIONS = "GET_PAST_SESSIONS";
export const GET_PROGRAM_SLOTS = "GET_PROGRAM_SLOTS";
export const GET_PROGRAM_EVENTS = "GET_PROGRAM_EVENTS";
export const GET_SESSION = "GET_SESSION";
export const GET_SPONSORS = "GET_SPONSORS";
export const GET_FAVOURITE_EVENTS = "GET_FAVOURITE_EVENTS";
export const CREATE_FAVOURITE = "CREATE_FAVOURITE";
export const DELETE_FAVOURITE = "DELETE_FAVOURITE";
export const GET_FAVOURITES = "GET_FAVOURITES";
export const GET_EPOSTERS = "GET_EPOSTERS";
export const GET_PROFILES = "GET_PROFILES";
export const GET_TAGS = "GET_TAGS";
export const GET_EPOSTER = "GET_EPOSTER";
export const GET_EPOSTER_QAS = "GET_EPOSTER_QAS";
export const CREATE_EPOSTER_QA = "CREATE_EPOSTER_QA";
export const GET_RELATED_EPOSTERS = "GET_RELATED_EPOSTERS";
export const GET_EXHIBITORS = "GET_EXHIBITORS";
export const GET_EXHIBITOR = "GET_EXHIBITOR";
export const GET_EXHIBITOR_PROFILES = "GET_EXHIBITOR_PROFILES";
export const GET_PROFILE_MEETING_SLOTS = "GET_PROFILE_MEETING_SLOTS";
export const CREATE_MEETING = "CREATE_MEETING";
export const GET_MEETING = "GET_MEETING";
export const GET_MEETINGS = "GET_MEETINGS";
export const DELETE_MEETING = "DELETE_MEETING";
export const GET_FAQS = "GET_FAQS";
export const GET_CONTACT_FAQS = "GET_CONTACT_FAQS";
export const GET_VIDEO_FAQS = "GET_VIDEO_FAQS";
export const GET_VIMEO_DATA = "GET_VIMEO_DATA";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const UPDATE_AVATAR_PROFILE = "UPDATE_AVATAR_PROFILE";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const GET_MY_POSTERS = "GET_MY_POSTERS";
export const CREATE_EPOSTER = "CREATE_EPOSTER";
export const UPDATE_EPOSTER = "UPDATE_EPOSTER";
export const DELETE_EPOSTER = "DELETE_EPOSTER";
export const UPDATE_QUESTION_ANSWER = "UPDATE_QUESTION_ANSWER";
export const DELETE_QUESTION_ANSWER = "DELETE_QUESTION_ANSWER";
export const GET_EXPERTS = "GET_EXPERTS";
export const GET_EXPERT = "GET_EXPERT";
export const GET_SPEAKER_SESSIONS = "GET_SPEAKER_SESSIONS";
export const UPDATE_MEETING_SLOT = "UPDATE_MEETING_SLOT";
export const GET_FORUM_TOPIC = "GET_FORUM_TOPIC";
export const GET_FORUM_TOPICS = "GET_FORUM_TOPICS";
export const CREATE_FORUM_TOPIC = "CREATE_FORUM_TOPIC";
export const UPDATE_FORUM_TOPIC = "UPDATE_FORUM_TOPIC";
export const GET_FORUM_POSTS = "GET_FORUM_POSTS";
export const CREATE_FORUM_POST = "CREATE_FORUM_POST";
export const UPDATE_EXHIBITOR = "UPDATE_EXHIBITOR";
export const GET_DOCUMENT = "GET_DOCUMENT";
export const GET_MODULE = "GET_MODULE";
export const GET_MODULE_QAS = "GET_MODULE_QAS";
export const CREATE_MODULE_QA = "CREATE_MODULE_QA";
export const UPDATE_MODULE_QA = "UPDATE_MODULE_QA";
export const DELETE_MODULE_QA = "DELETE_MODULE_QA";
export const UPDATE_MODULE = "UPDATE_MODULE";
export const CREATE_EXHIBITOR_DOCUMENT = "CREATE_EXHIBITOR_DOCUMENT";
export const UPDATE_DOCUMENT = "UPDATE_DOCUMENT";
export const DELETE_DOCUMENT = "DELETE_DOCUMENT";
export const UPDATE_DOCUMENT_PDF = "UPDATE_DOCUMENT_PDF";
export const GET_RECORDING = "GET_RECORDING";
export const CREATE_EXHIBITOR_RECORDING = "CREATE_EXHIBITOR_RECORDING";
export const UPDATE_RECORDING = "UPDATE_RECORDING";
export const DELETE_RECORDING = "DELETE_RECORDING";
export const UPDATE_IMAGE = "UPDATE_IMAGE";
export const UPDATE_EXPERT = "UPDATE_EXPERT";
export const GET_COURSES = "GET_COURSES";
export const GET_COURSE = "GET_COURSE";
export const GET_SURVEY = "GET_SURVEY";
export const CREATE_SURVEY_ATTEMPT = "CREATE_SURVEY_ATTEMPT";
export const GET_PROFILES_NAMES = "GET_PROFILES_NAMES";
export const GET_CERTIFICATES = "GET_CERTIFICATES";
export const GET_CERTIFICATES_FILTERED = "GET_CERTIFICATES_FILTERED";
export const GET_PROFILE = "GET_PROFILE";
export const GET_PROFILE_QAS = "GET_PROFILE_QAS";
export const CREATE_PROFILE_QA = "CREATE_PROFILE_QAS";
export const GET_PHYSICAL_ROOMS = "GET_PHYSICAL_ROOMS";
export const GET_PHYSICAL_ROOM = "GET_PHYSICAL_ROOM";
export const GET_PHYSICAL_ROOM_USERS = "GET_PHYSICAL_ROOM_USERS";
export const CREATE_QR_SCAN_LOG = "CREATE_QR_SCAN_LOG";
export const CREATE_BATCH_QR_SCAN_LOG = "CREATE_BATCH_QR_SCAN_LOG";
export const GET_SESSION_PRESENTATIONS = "GET_SESSION_PRESENTATIONS";
export const GET_SESSION_PRESENTATION = "GET_SESSION_PRESENTATION";
export const UPDATE_SESSION_PRESENTATION = "UPDATE_SESSION_PRESENTATION";
export const GET_EPOSTERS_INTERNAL_IDS = "GET_EPOSTERS_INTERNAL_IDS";
